





















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceAvailabilityDisplay from '@ui/AudienceAvailability/AudienceAvailabilityDisplay'

settings =
  name: 'AudienceAvailabilityShow'

  resources:
    audience_availability:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities/:audienceAvailabilityId'

  vue:
    components: {
      LoadingIndicator,
      AudienceAvailabilityDisplay,
    }

    data: ->
      audienceAvailabilityShowModal:
        show: true

    methods:
      hiClose: ->
        @$router.push { name: 'AudienceAvailabilityListPage' }

      hiTogglePublished: (published) ->
        payload = { audience_availability_id: @audience_availability.id }
        action = if published then 'publish' else 'unpublish'
        @triggerResource 'audience_availability', action, payload

export default VueOptions.vue settings
